import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SideBar from "../commanComponents/sidebar/sidebar";

import "./changePassword.css";
import { clearData } from '../../utils/localStorage';
import { ChangePasswordService } from '../../modules/services';
import { sidebarNavItems, ROUTES } from "../../constant";
import TopNavigation from "../commanComponents/topNavigation/topNavigation";
import InputField from '../commanComponents/inputField/inputField';
import { validateLoginPassword, validateConfirmPassword, validateNewPassword } from '../../utils/validations';


const ChangePassword = () => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [firstClick, setFirstClick] = useState(false);
    const [oldPasswordInvalid, setOldPasswordInvalid] = useState({ isError: false, errorMessage: "" });
    const [newPasswordInvalid, setNewPasswordInvalid] = useState({ isError: false, errorMessage: "" });
    const [confirmPasswordInvalid, setConfirmPasswordInvalid] = useState({isError: false, errorMessage: "" });
    const [passwordData, setPasswordData] = useState({
        password: "",
        new_password: "",
        confirm_password: ""
    });


    const handleOldPasswordChange = (password) => {
        setPasswordData({ ...passwordData, password: password });
        var errorMessage = validateLoginPassword(password);
        if (errorMessage === "") {
            setOldPasswordInvalid({ isError: false, errorMessage: "" });
        }
        else {
            setOldPasswordInvalid({isError: true, errorMessage: errorMessage});
        }
        setFirstClick(true);
    }

    const handleNewPasswordChange = (password) => {
        setPasswordData({ ...passwordData, new_password: password });
        var errorMessage = validateNewPassword(password);
        if (errorMessage === "") {
            setNewPasswordInvalid({ isError: false, errorMessage: "" });
        }
        else {
            setNewPasswordInvalid({isError: true, errorMessage: errorMessage});
        }
        setFirstClick(true);
    }

    const handleConfirmPasswordChange = (password) => {
        setPasswordData({ ...passwordData, confirm_password: password });
        var errorMessage = validateConfirmPassword(passwordData.new_password, password);
        if (errorMessage === "") {
            setConfirmPasswordInvalid({ isError: false, errorMessage: "" });
        }
        else {
            setConfirmPasswordInvalid({isError: true, errorMessage: errorMessage});
        }
        setFirstClick(true);
    }

    const handleChangePasswordSave = () => { 
        handleOldPasswordChange(passwordData.password);
        handleNewPasswordChange(passwordData.new_password);
        handleConfirmPasswordChange(passwordData.confirm_password);

        if (!oldPasswordInvalid.isError && !newPasswordInvalid.isError && !confirmPasswordInvalid.isError && firstClick) { 
            setIsLoading(true);

            (async () => {
                const responseData = await ChangePasswordService(passwordData, {});
                if (responseData !== "error" && (responseData.status_code === 200 || responseData.status_code === 201)) {
                    setIsLoading(false);
                    navigate(ROUTES.PROFILE);
                }
                else if(responseData !== "error" && (responseData.status_code !== 200 || responseData.status_code !== 201)) {
                    resetFields();
                }
                else {
                    clearData();
                    navigate(ROUTES.LOGIN);
                }
            })();
        }
    }

    const resetFields = () => {
        setIsLoading(false);
        setPasswordData({password: "", new_password: "", confirm_password: ""});
    }

    return (
        <div className='change-password-container' style={{ display: 'flex' }}>
            <SideBar activeItem={sidebarNavItems.profile} />
            <div className='change-password-side-container'>
                <TopNavigation activeItem={sidebarNavItems.profile} />
                
                <div className='row change-password-filter-container'>
                </div>
                
                <div className='change-password-main-container'>
                    <div className='row'>
                        <div className='col'>
                        <h5>Change Password</h5>
                        </div>
                        <div className='col change-password-header-right'>
                            <Button
                                variant="primary"
                                className='profile-change-password-button'
                                onClick={() => handleChangePasswordSave()}
                                disabled={isLoading}
                            >
                                {
                                    isLoading ?
                                        <Spinner animation="border" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </Spinner>
                                        :
                                        <span>SAVE</span>
                                }
                            </Button>
                        </div>
                    </div>
                    
                    <hr className="change-password-border" />
                    <div className='row change-password-input-div'>
                        <InputField
                            iconClass="bi-shield-lock-fill"
                            placeholder="Old Password"
                            fieldType="password"
                            isInvalid={oldPasswordInvalid.isError}
                            onChange={handleOldPasswordChange}
                            errorMessage={oldPasswordInvalid.errorMessage}
                            value={passwordData.password}
                            inputKey="old_password_key"
                        />
                        <InputField
                            iconClass="bi-shield-lock-fill"
                            placeholder="New Password"
                            fieldType="password"
                            isInvalid={newPasswordInvalid.isError}
                            onChange={handleNewPasswordChange}
                            errorMessage={newPasswordInvalid.errorMessage}
                            value={passwordData.new_password}
                            inputKey="new_password_key"
                        />
                        <InputField
                            iconClass="bi-shield-lock-fill"
                            placeholder="Confirm Password"
                            fieldType="password"
                            isInvalid={confirmPasswordInvalid.isError}
                            onChange={handleConfirmPasswordChange}
                            errorMessage={confirmPasswordInvalid.errorMessage}
                            value={passwordData.confirm_password}
                            inputKey="confirm_password_key"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
 }


export default ChangePassword;
